import React, { useContext, useEffect, useState, forwardRef, useImperativeHandle, useCallback, useMemo, useRef } from "react";
import classes from "../ServicesComponents.module.scss";
import { E2Data, DDD } from "../../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import Button from "../../UI/Button";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import OutboxIcon from '@mui/icons-material/Outbox';
import { OrgIdContext } from "../../../store/orgId_context";
import { ProgressBar } from "react-loader-spinner";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DownloadIcon from '@mui/icons-material/Download';
import { useForm, Controller  } from "react-hook-form";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { DateTimeField } from "../../integrationWizard/form/DateTimeField";
import { DateField } from "../../integrationWizard/form/DateField";
import { Checkbox } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import useInterval from "../../../lib/useInterval";
import { NotificationManager} from 'react-notifications';
import { normalizeLocaleCode } from "../../../lib/normalizeLocaleCode";
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import "../../table/customStyles.css";
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-balham.css"; 
import useEffectIgnoreFirst from "../../../hooks/useEffectIgnoreFirst";

ModuleRegistry.registerModules([InfiniteRowModelModule]);

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2data = new E2Data("EU_ExportFileProperties");
e2data.format = "full";
const threeMonthsAgo = new Date();
threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
const isoDate = threeMonthsAgo.toISOString().split('T')[0]; // YYYY-MM-DD
e2data.filter = `OrganisationName <> 'ALL' AND XLSExpirationDate >= '${isoDate}'`;
e2data.orderBy="DateTimeCreate desc"

const PasswordInput = ({pass}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (<>
        {pass && 
        <div className={`${classes["showpassicon"]} d-flex justify-content-center`} style={{padding:0, margin:0}}>
            {showPassword ? pass : "*".repeat(pass.length)}
            <span className={classes["showpassiconnormal"]} onClick={togglePasswordVisibility}>{showPassword ?  <VisibilityOffIcon/> : <RemoveRedEyeIcon/>}</span>
        </div>
        }
    </>);
};

const ExportOrganizationData =  forwardRef(({ filter, modal, mode, onSubmit }, ref) => {
    const { t , i18n} = useTranslation();
    const {sessionInfo} = useContext(OrgIdContext);
    /* const [mode, setMode] = useState("view"); */
    const [invType, setInvType] = useState("IEI");
    const [invExportType, setInvExportType] = useState("archival");
    const [groupBy, setGroupBy] = useState("IssueDate");
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);
    const [einvoices, setEinvoices] = useState(true);
    const [pdfs, setPdfs] = useState(true);
    const [attachments, setAttachments] = useState(true);
    const [password, setPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const currentLanguage = normalizeLocaleCode(i18n.language); 
    const table = useRef();
    const [requestParams, setRequestParams] = useState({});
    const [totalRecords, setTotalRecords] = useState("-");

    const {isPending : isDataPending, data, refetch} = useQuery({
        queryKey: ['Data.GetEntityData', e2data.GetParamsObject()],
        queryFn: () => e2data.GetData()
    })

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
    } = useForm();

    /* useEffect(() => {
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        const isoDate = threeMonthsAgo.toISOString().split('T')[0]; // YYYY-MM-DD
        //e2data.filter = `OrganisationName <> 'ALL' AND XLSExpirationDate >= '${isoDate}'`;
        e2data.filter = `OrganisationName <> 'ALL' AND DateTimeCreate >= '${isoDate}'`;
        if(filter) e2data.filter += ` AND ${filter}`;
        refetch();
    }, [filter, refetch]); */

    useInterval(() => {
        //refetch();
        table?.current?.api?.refreshInfiniteCache();
    }, 10000);

    const getIconForDirection = (direction, row) =>{
        let cclass = "main-blue";
        /* if(row?.Status === "Finished" && row?.XLSExpirationDate && new Date(row?.XLSExpirationDate) > new Date())
            cclass = "text-success"; */
        switch(direction){
            case "REI":
                return <MoveToInboxIcon className={cclass}/>
            case "IEI":
                return <OutboxIcon className={cclass}/>
            default:
                return <OutboxIcon className={cclass}/>
        }
    }

    const getPeriodNaming = (period, archival) =>{
        switch(period){
            case "IssueDate":
                return t("Issue date");
            case "ReceiveDate":
                return t("Receive date");
            case "DeliveryDate":
                return t("Delivery date");
            default:
                if(archival) return t("Invoice number");
                return "";
        }
    }

    const getIconForStatus = (status, row) =>{
        switch(status){
            case "Finished":
                return <CheckCircleIcon style={{color:"green", fontSize:"1rem"}}/>
            case "In progress":
                return <ProgressBar width="30" height="30" barColor="green" borderColor="#005683"/>
            case "Error":
                return <OverlayTrigger placement="top" overlay={<Tooltip>{row?.ErrorDescription||"An unknown error occurred"}</Tooltip>}>
                            <ErrorIcon style={{color:"red", fontSize:"1rem"}}/>
                        </OverlayTrigger>
            default:
                return <></>
        }
    }

    const downloadZip = (row) => {
        const link = document.createElement('a');
        link.href = window.location.origin+"/"+row.ZIPPath;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        const data = new E2Data("EU_ExportFileProperties");
        data.filter = `Id = '${row.Id}'`;
        data.values = {ZIPDownloadedDateTime : new Date().toISOString()};
        data.Modify().then((res) => {
            table?.current?.api?.refreshInfiniteCache();
        });
    }
    
    const downloadXLS = (row) => {
        const link = document.createElement('a');
        link.href = window.location.origin+"/"+row.XLSPath;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        const data = new E2Data("EU_ExportFileProperties");
        data.filter = `Id = '${row.Id}'`;
        data.values = {XLSDownloadedDateTime : new Date().toISOString()};
        data.Modify().then((res) => {
            table?.current?.api?.refreshInfiniteCache();
        });
    }

    const getFieldKey= () =>{
        switch (groupBy){
            case "IssueDate":
                return "InvIssueDate";
            case "ReceiveDate":
                return "DateTimeCreate";
            case "DeliveryDate":
                return "DeliveryDateActual";
            default:
                return "InvIssueDate";
        }
    }

    const getData = () =>{
        const toEndOfDay = new Date(to);
        toEndOfDay.setHours(23, 59, 59, 999);
        const toIso = toEndOfDay.toISOString();
        let ret= {
            "Destination": invType,
            "Filter": null,
            "TypeOfZip": invExportType,
            "FromDash" : true,
            "Period": groupBy,
            "Include": [],
            "PasswordProtected": password,
            "PeriodFrom": from ? new Date(from).toISOString() : null,
            "PeriodTo": to ? toIso : null,
        }

        ret.Filter = "";
        if(ret.PeriodFrom)
            ret.Filter = `${getFieldKey()} >= '${ret.PeriodFrom}'`;
        if(ret.PeriodFrom && ret.PeriodTo)
            ret.Filter += ` AND `;
        if(ret.PeriodTo)
            ret.Filter += `${getFieldKey()} <= '${ret.PeriodTo}'`;
        if(ret.Filter ==="") ret.Filter=null;

        if(pdfs) ret.Include.push("PDF");
        if(einvoices) ret.Include.push("XML");
        if(attachments) ret.Include.push("Attachments");

        return ret;
    }

    const _setError = (err) =>{
        setError(err);
        setTimeout(() =>{
            setError(null);
        }, 5000);
    }

    const onSubmitClick = useCallback(() => {
        const data = getData();
        if(data.Include.length === 0)
            return _setError(t("Please select at least one document type"));

        if(onSubmit) onSubmit(data);
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.GetFilesFromEUeInvoicesInPDF", data).then((res) => {
            //refetch();
            table?.current?.api?.refreshInfiniteCache();
            if(res?.result?.Status === "Error" || res?.error)
                return _setError(res?.result?.Reason||res?.error?.data);
            NotificationManager.success(t("ZIP created"), t("Success"), 5000);
        });

        setTimeout(() => {
            //refetch();
            table?.current?.api?.refreshInfiniteCache();
        }, 1000);
    }, [getData, t, _setError, apiRequestAddress, refetch]);

    useImperativeHandle(ref, () => ({
        submit: onSubmitClick
    }), [onSubmitClick]);

    const columnDefs = useMemo(() => [
    {
      headerName: t("Direction"),
      field: "Destination",
      width: 40,
      cellRenderer: (params) => {
        return (
          <div className="text-center">
            {getIconForDirection(params?.value, params?.data)}
          </div>
        );
      },
      tooltipField: "Destination",
      sortable: true,
    },
    {
      headerName: t("Status"),
      field: "Status",
      width: 80,
      cellRenderer: (params) => <div className="text-center">{getIconForStatus(params?.value, params?.data)}</div>,
      sortable: true,
    },
    {
      headerName: t("Expiration"),
      field: "XLSExpirationDate",
      width: 30,
      cellRenderer: ({ value }) => {
        const t = new Date(); t.setHours(0,0,0,0);
        const d = value ? new Date(value) : null;
        const expired = !d || isNaN(d) || d < t;
        return (
            <div className="text-center">
            {expired
                ? <OverlayTrigger placement="top" overlay={<Tooltip>{"Expired"}</Tooltip>}>
                    <HighlightOffIcon style={{ fontSize:"1rem", color:"var(--main-blue)" }} />
                  </OverlayTrigger>
                : <OverlayTrigger placement="top" overlay={<Tooltip>{"Not expired"}</Tooltip>}>
                    <CheckCircleIcon style={{ fontSize:"1rem", color:"var(--main-blue)" }} />
                  </OverlayTrigger>
                }
            </div>
        );
        }
    },
    {
      headerName: t("Expires"),
      field: "XLSExpirationDate",
      width: 150,
      valueFormatter: (params) =>
        params?.value
          ? new Date(params?.value).toLocaleString(currentLanguage, {
              day: "numeric",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "",
      sortable: true,
    },
    {
      headerName: t("Created"),
      field: "XLSDateTimeCreate",
      width: 150,
      valueFormatter: (params) =>
        params?.value
          ? new Date(params?.value).toLocaleString(currentLanguage, {
              day: "numeric",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "",
      sortable: true,
      sort: "desc",
    },
    {
      headerName: t("Export Type"),
      field: "ExportType",
      width: 120,
      cellRenderer: (params) => params?.value || "",
    },
    {
      headerName: t("Grouped"),
      field: "PeriodBy",
      width: 120,
      valueFormatter: (params) => getPeriodNaming(params?.value, params?.data?.ExportType?.toLowerCase() === "archival"),
      sortable: true,
    },
    {
      headerName: t("Period"),
      field: "Period",
      width: 200,
      cellRenderer: (params) => {
        if(!params?.data) return "";
        const { PeriodFrom, PeriodTo, PeriodBy } = params?.data;
        return (
          <>
            {PeriodFrom && !PeriodTo && <span>{t("From")}:</span>}
            {PeriodTo && !PeriodFrom && <span>{t("To")}:</span>}
            {PeriodFrom && new Date(PeriodFrom).toLocaleDateString(currentLanguage)}
            {PeriodFrom && PeriodTo && <> - </>}
            {PeriodTo && new Date(PeriodTo).toLocaleDateString(currentLanguage)}
          </>
        );
      },
      sortable: false,
    },
    
    {
      headerName: t("Password"),
      field: "Password",
      width: 80,
      cellRenderer: (params) => <PasswordInput pass={params?.value} />,
    },
    {
      headerName: t("Download"),
      field: "Download",
      width: 120,
      cellRenderer: (params) => {
        if(!params?.data) return "";
        const { XLSPath, XLSDownloadedDateTime, ZIPPath, ZIPDownloadedDateTime } = params?.data;
        const btn = (label, date, handler) => (
            <OverlayTrigger
                placement="top"
                overlay={
                <Tooltip>
                    {date
                    ? `${t("Downloaded")}: ${new Date(date).toLocaleString(currentLanguage)}`
                    : t("Download")}
                </Tooltip>
                }
            >
                <button
                type="button"
                className={`${classes.downloadBtn} ${date ? classes.downloaded : ""}`}
                onClick={handler}
                >
                {label}
                </button>
            </OverlayTrigger>
        );
        return (
          <div className={classes.downloadContainer}>
            {ZIPPath && btn("ZIP", ZIPDownloadedDateTime, () => downloadZip(params.data))}
            {XLSPath && btn("XLS", XLSDownloadedDateTime, () => downloadXLS(params.data))}
        </div>
        );
      },
    },
    
    {
      headerName: t("ZIP Downloaded Date"),
      field: "ZIPDownloadedDateTime",
      width: 150,
      valueFormatter: (params) =>
        params?.value
          ? new Date(params?.value).toLocaleString(currentLanguage, {
              day: "numeric",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "",
    },
    {
      headerName: t("XLS Downloaded Date"),
      field: "XLSDownloadedDateTime",
      width: 150,
      valueFormatter: (params) =>
        params?.value
          ? new Date(params?.value).toLocaleString(currentLanguage, {
              day: "numeric",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "",
    },
  ], []);

    const defaultColDef = useMemo(() => {
          return {
              //flex: 1,
              minWidth: 100,
              sortable: true,
              tooltipShowDelay: 0,
          }
    }, []);

    const onGridReady = useCallback((params) => {
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                setRequestParams(reqParams);
                reqParams.filter = filter;
                loadEntityData(reqParams).then((res) =>{
                    setTotalRecords(res?.result?.count ?? "-");
                    reqParams.successCallback(res?.result?.data, res?.result?.count);
                });
            }
        }
        params.api.setGridOption('datasource', dataSource);
    });

    const loadEntityData = ({startRow,endRow,filter, sortModel}) => {
        const e2data= new E2Data("EU_ExportFileProperties");
        e2data.format="Full"
        e2data.includeCount=true;
        e2data.skip=startRow;
        e2data.take=endRow-startRow;
        e2data.component= "*";
        e2data.filter=getFilter(filter);
        e2data.orderBy=getOrderByFromArray(sortModel);
        return e2data.GetData();
    }

    const getFilter = (filter) =>{
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        const isoDate = threeMonthsAgo.toISOString().split('T')[0]; // YYYY-MM-DD
        let _filter = `OrganisationName <> 'ALL'`;
        if(filter) _filter += ` AND ${filter}`;
        return _filter;
    }

    const getOrderByFromArray = (arr) => {
        if(!arr?.length) return null;

        let order = "";
        arr.forEach(item => order+= item.colId + " " + item.sort+", ");
        order = order.replace(/, +$/, "");
        return order;
    }
    
    useEffectIgnoreFirst(() => {
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                reqParams.filter = filter;
                setRequestParams(reqParams);
                loadEntityData(reqParams).then((res) =>{
                    setTotalRecords(res?.result?.count ?? "-");
                    reqParams.successCallback(res?.result?.data, res?.result?.count);
                });
            }
        }
        table?.current?.api?.setGridOption('datasource', dataSource);
    }, [filter])

    return (
      <>
        <div className={`w-100`}>
            {error && <div className="alert alert-warning" role="alert">
                {error}
            </div>}
            {mode === "view" && <><Container className={`${classes["titleContainer"]} g-0`} style={{maxWidth:"none"}}> 
                <div className="ag-theme-balham custom-ag-grid" style={{ width: "100%", overflowX: "auto", height: "500px" }}>
                <AgGridReact
                ref={table}
                rowBuffer={0}
                onGridReady={onGridReady}
                rowSelection={'single'}
                rowModelType={'infinite'}
                cacheBlockSize={100}
                cacheOverflowSize={2}
                maxConcurrentDatasourceRequests={1}
                infiniteInitialRowCount={1000}
                maxBlocksInCache={10}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                suppressHorizontalScroll={false}
                />
                </div>
            </Container></>}
            {/* {mode === "view" && <><Container className={`${classes["titleContainer"]} g-0`} style={{maxWidth:"none"}}> 
                <Row className="g-0">
                    <Col className="col-1 border  text-center">{t("Direction")}</Col> 
                    <Col className="col-2 border  text-center">{t("Created")}</Col>
                    <Col className="col-2 border  text-center">{t("Expires")}</Col>
                    <Col className="col-3 border  text-center">{t("Period")}</Col>
                    <Col className="col-1 border  text-center">{t("Grouped")}</Col>
                    <Col className="col-1 border  text-center">{t("Status")}</Col>
                    <Col className="col-1 border  text-center">{t("Password")}</Col>
                    <Col className="col-1 border  text-center">{t("Download")}</Col>
                </Row>
            </Container>
            {data?.result?.data?.map((row, index) => {
                return(
                    <Container className={`${classes["rowContainer"]} g-0`} style={index%2===0 ? {backgroundColor:"#f1f5fd", maxWidth:"none"} : {backgroundColor:"#f9fbff", maxWidth:"none"}}>
                        <Row  className={`${classes["tableRow"]} g-0`}>
                            <Col className={`col-1 ${classes["trcol"]} text-center`}>
                                <OverlayTrigger placement="top" overlay={<Tooltip>{row?.Destination}</Tooltip>}>
                                    {getIconForDirection(row?.Destination, row)}
                                </OverlayTrigger>
                            </Col>
                            <Col className={`col-2 ${classes["trcol"]}`}>{row?.XLSDateTimeCreate && sessionInfo && new Date(row?.XLSDateTimeCreate).toLocaleString(currentLanguage, {day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'})}</Col>
                            <Col className={`col-2 ${classes["trcol"]}`}>{row?.XLSExpirationDate && sessionInfo && new Date(row?.XLSExpirationDate).toLocaleString(currentLanguage, {day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'})}</Col>
                            <Col className={`col-3 ${classes["trcol"]}`}>
                            {row?.PeriodFrom && !row?.PeriodTo && <><span className="me-2">{t("From")}:</span></>}
                            {row?.PeriodTo && !row?.PeriodFrom && <><span className="me-2">{t("To")}:</span></>}
                            {row?.PeriodFrom && sessionInfo && new Date(row?.PeriodFrom).toLocaleString(currentLanguage, {day: 'numeric', month: 'short', year: 'numeric'})}
                            {row?.PeriodFrom && row?.PeriodTo && <>-</>}
                            {row?.PeriodTo && sessionInfo && new Date(row?.PeriodTo).toLocaleString(currentLanguage, {day: 'numeric', month: 'short', year: 'numeric'})}
                            </Col>
                            <Col className={`col-1 ${classes["trcol"]}`}>{getPeriodNaming(row?.PeriodBy)}</Col>
                            <Col className={`col-1 ${classes["trcol"]}`}>{getIconForStatus(row?.Status, row)}</Col>
                            <Col className={`col-1 ${classes["trcol"]}`}><PasswordInput pass={row?.Password}/></Col>
                            <Col className={`col-1 ${classes["trcol"]}`}>
                                {row?.Status ==="Finished" && <div className="d-flex m-0 p-0 justify-content-around" >
                                    {row?.ZIPPath && <>
                                        <OverlayTrigger placement="top" overlay={<Tooltip>{row.ZIPDownloadedDateTime ? <>{t("Downloaded")}:{new Date(row.ZIPDownloadedDateTime).toLocaleString(currentLanguage)}</> : t("Download")}</Tooltip>}>
                                        <div className={`${classes["download-btn"]} m-0 p-0`} style={row.ZIPDownloadedDateTime ? {backgroundColor:"green"}:{}} onClick={() => downloadZip(row)}>
                                            <div className="m-0 p-0" style={{fontSize:"0.5rem"}}>ZIP</div>
                                            <DownloadIcon/>
                                        </div>
                                        </OverlayTrigger></>}
                                    {row?.XLSPath && <>
                                        <OverlayTrigger placement="top" overlay={<Tooltip>{row.XLSDownloadedDateTime ? <>{t("Downloaded")}:{new Date(row.XLSDownloadedDateTime).toLocaleString(currentLanguage)}</> : t("Download")}</Tooltip>}>
                                        <div className={`${classes["download-btn"]} m-0 p-0`} style={row.XLSDownloadedDateTime ? {backgroundColor:"green"}:{}} onClick={() => downloadXLS(row)}>
                                            <div className="m-0 p-0" style={{fontSize:"0.5rem"}}>XLS</div>
                                            <DownloadIcon/>
                                        </div>
                                        </OverlayTrigger></>}
                                </div>}
                            </Col>
                        </Row>
                    </Container>
                )
            })}
            </>} */}
            {mode==="create" && <>
                    {/* <div className={classes.Fcontainer}> */}
                    <div className="d-flex justify-content-center">
                        <div>
                        <FormControl style={{display:"block"}}>
                            <FormLabel id="demo-controlled-radio-buttons-group">{t("Type of invoice")}:</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={invType}
                                row
                                onChange={(d) => {setInvType(d.target.value); d.target.value === "IEI" ? setGroupBy("IssueDate") : setGroupBy("ReceiveDate")}}
                            >
                                <FormControlLabel value="IEI" control={<Radio />} label={t("Issued")} />
                                <FormControlLabel value="REI" control={<Radio />} label={t("Received")} />
                            </RadioGroup>
                        </FormControl>
                        <FormControl style={{display:"block"}}>
                            <FormLabel id="demo-controlled-radio-buttons-group">{t("Type of export")}:</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={invExportType}
                                row
                                onChange={(d) => {
                                    setInvExportType(d.target.value);
                                    if(d.target.value === "operative") {
                                        setPassword(false);
                                    } else {
                                        setPassword(true);
                                    }
                                }}
                            >
                                <FormControlLabel value="archival" control={<Radio />} label={t("Archival")} />
                                <FormControlLabel value="operative" control={<Radio />} label={t("Operative")} />
                            </RadioGroup>
                        </FormControl>
                        <FormControl style={{display:"block"}}>
                            <FormLabel id="demo-controlled-radio-buttons-group">{t("Group into monthly folders by")}:</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={groupBy}
                                row
                                onChange={(d) => setGroupBy(d.target.value)}
                            >
                                <FormControlLabel value="NoPeriodGrouping" control={<Radio />} label={invExportType !== "operative" ? t("Invoice number") : t("No group")} />
                                {invType !== "REI" && <FormControlLabel value="IssueDate" control={<Radio />} label={t("Issued date")} />}
                                {invType !== "IEI" && <FormControlLabel value="ReceiveDate" control={<Radio />} label={t("Received date")} />}
                                <FormControlLabel value="DeliveryDate" control={<Radio />} label={t("Delivery date")} />
                            </RadioGroup>
                        </FormControl>
                        <FormControl style={{display:"block"}}>
                            <FormLabel id="demo-controlled-radio-buttons-group">{t("Period")}:</FormLabel>
                                <div className="d-flex mt-2">
                                    <input 
                                        type= "date"
                                        name={"from"}
                                        key={"from"}
                                        value = {from}
                                        className={classes["dateinput"]}
                                        onChange={(e) => {setFrom(e.target.value)}}
                                        ></input>
                                        <span className="ms-2 me-2">-</span>
                                    <input 
                                        type= "date"
                                        name={"to"}
                                        key={"to"}
                                        value = {to}
                                        className={classes["dateinput"]}
                                        onChange={(e) => {
                                            setTo(e.target.value);
                                            /*const d = new Date(e.target.value);
                                            d.setHours(23, 59, 59, 999);
                                            setTo(d.toISOString())*/
                                        }}
                                        ></input>
                                </div>
                        </FormControl>
                        <FormControl style={{display:"block", marginTop:"10px"}}>
                            <FormLabel id="demo-controlled-radio-buttons-group">{t("Which documents")}<span className="text-danger">*</span>:</FormLabel>
                                <div className="d-flex mt-2">
                                    <FormControlLabel control={<Checkbox checked={einvoices} onChange={(e)=>{setEinvoices(e.target.checked)}} inputProps={{ 'aria-label': 'controlled' }}/>} label={t("E-Invoices (XML)")} />
                                    <FormControlLabel control={<Checkbox checked={pdfs} onChange={(e)=>{setPdfs(e.target.checked)}} inputProps={{ 'aria-label': 'controlled' }}/>} label={t("Invoices (PDF)")} />
                                    <FormControlLabel control={<Checkbox checked={attachments} onChange={(e)=>{setAttachments(e.target.checked)}} inputProps={{ 'aria-label': 'controlled' }}/>} label={t("Attachments")} />
                                </div>
                        </FormControl>
                        {invExportType !== "operative" && 
                        <FormControl style={{display:"block", marginTop:"10px"}}>
                            <FormLabel id="demo-controlled-radio-buttons-group">{t("Password")}:</FormLabel>
                                <div className="d-flex mt-2">
                                    <FormControlLabel control={<Checkbox checked={password} onChange={(e)=>{setPassword(e.target.checked)}} inputProps={{ 'aria-label': 'controlled' }}/>} label={t("Password protect ZIP")} />
                                </div>
                        </FormControl>}
                        </div>
                    </div>
                    {/* {!modal && 
                    <div className="text-end mt-3">
                        <Button onClick={() => setMode("view")}>{t("Cancel")}</Button>
                        <Button className="ms-2" onClick={onSubmitClick}>{t("Create new export")}</Button>
                    </div>} */}
            </>}
        </div>
      </>
    );
});
  
export default ExportOrganizationData;




  